import React, { useState, useEffect, useMemo } from 'react'
import Wrapper from '../../components/Wrapper'
import { useNavigate, useParams } from 'react-router-dom'
import { Typography, Box, Paper, IconButton, TextField, Autocomplete, Grid, Alert, Button, Select, MenuItem, FormControl, InputLabel, ToggleButton, ToggleButtonGroup, Switch, FormControlLabel, ListSubheader } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import InfoIcon from '@mui/icons-material/Info'
import RefreshIcon from '@mui/icons-material/Refresh'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { menu, group, weekDays, input, short, readyShortName, lang, shortFunctionList, ivr } from '../../translate'
import Api from '../../Api'
import { greenTheme, sectionTitleStyles, groupPageStyles, titleTypographyStyles, customStyles } from '../../helpers/style'

const { REACT_APP_SERVER } = process.env
const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : greenTheme.primary
const hoverColor = REACT_APP_SERVER === 'ATS' ? '#095a8f' : greenTheme.hover
const themeColors = { primary: primaryColor, hover: hoverColor }
const inputStylesLocal = {
    '& .MuiOutlinedInput-root': { minHeight: '41px', '& fieldset': { borderColor: primaryColor }, '&:hover fieldset': { borderColor: hoverColor }, '&.Mui-focused fieldset': { borderColor: primaryColor } },
    '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
}
const inputLabelStylesLocal = { '&.Mui-focused': { color: primaryColor } }
const selectStylesLocal = {
    '& .MuiOutlinedInput-root': { minHeight: '41px' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: hoverColor },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
}
const customStylesLocal = {
    ...customStyles,
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? primaryColor : base.borderColor,
        boxShadow: state.isFocused ? `0 0 0 1px ${primaryColor}` : base.boxShadow,
        '&:hover': { borderColor: primaryColor },
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: (state.isSelected || state.isFocused) ? `${primaryColor}26` : base.backgroundColor,
        color: '#000',
        border: 'none',
        borderTop: 'none',
        borderBottom: 'none',
        outline: 'none',
        WebkitTapHighlightColor: 'transparent',
    }),
}
import { DndContext, closestCorners, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import EmployeeCard from '../../components/new_component/EmployeeCard'
import { toast } from 'react-toastify'
import CreatableSelect from 'react-select/creatable'
export default function Group() {
    const langIndex = +localStorage.getItem('atsLang') || 1
    const { id } = useParams()
    const navigate = useNavigate()
    const [form, setForm] = useState({
        shortNumberName: '',
        shortNumber: '',
        noAnswerShort: '',
        is_order: 0,
        send_mail: [],
        mainEmployee: '',
        simultaneousCall: false,
        callWaitTime: '50',
        employees: [{
            id: Date.now(),
            employee: '',
            startDay: '2',
            endDay: '1',
            startHour: '00',
            startMinute: '00',
            endHour: '23',
            endMinute: '59',
            is_order: 0,
        }],
    })
    const [shortNumbers, setShortNumbers] = useState([])
    const [expandedNoAnswerGroups, setExpandedNoAnswerGroups] = useState({ group: true, ivr: true })
    const nameOptions = Object.values(readyShortName).map(option => option[langIndex] || option[1])
    const [employees, setEmployees] = useState([])
    const [loading, setLoading] = useState(false)
    const emailTlds = ['.com', '.ru', '.am']
    const [emailInput, setEmailInput] = useState('')

    const noAnswerOptions = useMemo(() => {
        const shortTrim = String(form.shortNumber || '').trim()
        const alreadyInList = shortNumbers.some(s => String(s.virtual) === shortTrim)
        const currentShortOption = shortTrim && !alreadyInList
            ? [{ virtual: shortTrim, id: 'current-short', name: shortTrim, label: `${shortTrim} (${langIndex === 2 ? 'Номер этой группы' : langIndex === 3 ? 'Այս խմբի համար' : 'This group'})`, isivr: 0 }]
            : []
        return [...currentShortOption, ...shortNumbers]
    }, [form.shortNumber, shortNumbers, langIndex])

    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                if (id !== 'add') {
                    const response = await Api.groupsGetSingle(id)
                    if (response?.data?.status === 'ok') {
                        let single = response.data.data
                        let employeesData = (single.item || []).map(item => {
                            const daysParts = item.days ? item.days.split('-') : ['2', '1']
                            const hoursParts = item.hours ? item.hours.split(/[:-]/) : ['00', '00', '23', '59']
                            return {
                                id: item.id || Date.now(),
                                employee: item.buddy || '',
                                startDay: daysParts[0] || '2',
                                endDay: daysParts[1] || '1',
                                startHour: hoursParts[0] || '00',
                                startMinute: hoursParts[1] || '00',
                                endHour: hoursParts[2] || '23',
                                endMinute: hoursParts[3] || '59',
                                is_order: item.is_order || 0,
                            }
                        })
                        const mainEmployeeItem = (single.item || []).find(item => item.general_sip)
                        let noAnswerValue = ''
                        if (single.noaction !== null && single.noaction !== undefined && single.noaction !== '') {
                            const matchingOption = shortNumbers.find(s => s.virtual === String(single.noaction))
                            noAnswerValue = matchingOption || String(single.noaction)
                        }
                        const sendMailArray = single.send_mail
                            ? (Array.isArray(single.send_mail) ? single.send_mail : single.send_mail.split(',').map((m) => m.trim()).filter(Boolean))
                            : []
                        setForm({
                            shortNumberName: single.name || '',
                            shortNumber: single.virtual !== null && single.virtual !== undefined ? String(single.virtual) : '',
                            noAnswerShort: noAnswerValue,
                            is_order: single.is_order || 0,
                            send_mail: sendMailArray,
                            mainEmployee: mainEmployeeItem ? mainEmployeeItem.buddy : '',
                            simultaneousCall: single.is_order === 1 ? true : single.cwaiting === 1,
                            callWaitTime: single.timeout || '',
                            employees: employeesData.length > 0 ? employeesData : [{
                                id: Date.now(),
                                employee: '',
                                startDay: '2',
                                endDay: '1',
                                startHour: '00',
                                startMinute: '00',
                                endHour: '23',
                                endMinute: '59',
                                is_order: 0,
                            }],
                        })
                    }
                }
            } catch (error) {
                console.error('Error fetching group:', error)
            } finally {
                setLoading(false)
            }
        })()
    }, [id, shortNumbers])
    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: {
                distance: 5,
            },
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 100,
                tolerance: 5,
            },
        })
    )

    useEffect(() => {
        fetchShortNumbers()
    }, [])

    const fetchShortNumbers = async () => {
        setLoading(true)
        try {
            const [groupsResponse, shortNumbersRes] = await Promise.all([
                Api.groupsGet(1),
                Api.shortGetShortNumbers().catch(() => ({ data: { data: [] } })),
            ])
            const rawFnList = shortNumbersRes?.data?.data || []
            const fnList = rawFnList.length ? rawFnList : [{ function_code: '10888' }, { function_code: '10777' }]
            const functionCodeOptions = fnList.map((l) => {
                const code = String(l.function_code ?? l.code ?? '')
                const label =
                    l?.[lang[langIndex]] ||
                    l?.[lang[1]] ||
                    readyShortName?.[code]?.[langIndex] ||
                    readyShortName?.[code]?.[1] ||
                    shortFunctionList?.[code]?.[langIndex] ||
                    code
                return {
                    id: `fn-${code}`,
                    virtual: code,
                    name: label,
                    label,
                    isivr: -1,
                }
            }).filter((fc) => fc.virtual && fc.virtual !== '568898' && fc.virtual !== '789989')
            if (groupsResponse?.data?.status === 'ok') {
                const shortGroups = groupsResponse.data.data || []
                const groupOptions = shortGroups
                    .filter((g) => String(g.virtual) !== '568898' && String(g.virtual) !== '789989' && Number(g.autostatus) !== 25)
                    .map((g) => ({
                        id: g.id,
                        virtual: g.virtual,
                        name: g.name || `Short ${g.virtual}`,
                        label: `${g.virtual}${g.name ? ` - ${g.name}` : ''}`,
                        isivr: g.isivr ?? 0,
                    }))
                const activated = []
                if (shortGroups.some((g) => String(g.virtual) === '568898')) {
                    const label = shortFunctionList?.['568898']?.[langIndex] || 'Call center'
                    activated.push({ id: 'fn-568898', virtual: '568898', name: label, label, isivr: -1 })
                }
                const familiarIndex = functionCodeOptions.findIndex((f) => String(f.virtual) === '10999')
                if (familiarIndex >= 0) functionCodeOptions.splice(familiarIndex + 1, 0, ...activated)
                else functionCodeOptions.push(...activated)
                const allShortNumbers = [...functionCodeOptions, ...groupOptions]
                setShortNumbers(allShortNumbers)
                const employeeList = groupsResponse.data?.employees || []
                setEmployees(employeeList.map(emp => ({
                    id: emp.id || emp.buddy,
                    buddy: emp.buddy,
                    name: emp.name || emp.notes || emp.buddy,
                    label: `${emp.buddy}${emp.name ? ` - ${emp.name}` : ''}`,
                })))
            } else {
                setShortNumbers(functionCodeOptions.filter((fc) => fc.virtual))
            }
        } catch (error) {
            console.error('Error fetching short numbers:', error)
        } finally {
            setLoading(false)
        }
    }


    const handleGoBack = () => {
        navigate('/groups')
    }

    const handleGenerateShortNumber = () => {
        const groupItems = shortNumbers.filter(item => item.isivr === 0 && +item.virtual !== 59999 && +item.virtual !== 568898)
        const currentVirtual = String(form.shortNumber || '').trim()
        const used = new Set(
            groupItems
                .filter(item => !(id !== 'add' && currentVirtual && String(item.virtual) === currentVirtual))
                .map(item => Number(item.virtual) || 0)
        )
        let newShortNumber = 1
        while (used.has(newShortNumber)) newShortNumber++
        setForm({ ...form, shortNumber: String(newShortNumber) })
    }

    const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

    const handleSendMailChange = (values) => {
        const emails = values?.map(v => v.value) || []
        setForm((prev) => ({
            ...prev,
            send_mail: emails
        }))
        setEmailInput('')
    }

    const handleCreateEmail = (value) => {
        const trimmed = value.trim()
        const candidate = (() => {
            if (isValidEmail(trimmed)) return trimmed
            if (!trimmed.includes('@')) return ''
            const hasTld = /\.[a-zA-Z]{2,}$/.test(trimmed)
            if (hasTld) return ''
            const fallback = `${trimmed}.com`
            return isValidEmail(fallback) ? fallback : ''
        })()
        if (!candidate) {
            toast.error('Enter a valid email')
            return
        }
        handleSendMailChange([...(form.send_mail || []).map(e => ({ value: e, label: e })), {
            value: candidate,
            label: candidate
        }])
    }

    const emailOptions = useMemo(() => {
        const selected = (Array.isArray(form.send_mail) ? form.send_mail : [])
            .map(email => ({ value: email, label: email }))
        const trimmed = emailInput.trim()
        const hasAt = trimmed.includes('@')
        const hasTld = /\.[a-zA-Z]{2,}$/.test(trimmed)
        const suggestions = hasAt && !hasTld
            ? emailTlds
                .map(tld => {
                    const value = `${trimmed}${tld}`
                    return { value, label: value }
                })
                .filter(opt => !selected.find(sel => sel.value === opt.value))
            : []
        return [...suggestions, ...selected]
    }, [emailInput, form.send_mail])

    const handleSave = async () => {
        const nameTrim = String(form.shortNumberName || '').trim()
        if (!nameTrim) {
            toast.error(group.short_number_name_label[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
            return
        }
        const shortTrim = String(form.shortNumber || '').trim()
        if (!shortTrim) {
            toast.error(group.short_number_label[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
            return
        }
        const noAnswerValue = typeof form.noAnswerShort === 'object' && form.noAnswerShort?.virtual
            ? form.noAnswerShort.virtual
            : form.noAnswerShort
        if (!noAnswerValue || String(noAnswerValue).trim() === '') {
            toast.error(group.no_answer_short_label[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
            return
        }
        try {
            const formData = {
                ...form,
                noAnswerShort: typeof form.noAnswerShort === 'object' && form.noAnswerShort?.virtual 
                    ? form.noAnswerShort.virtual 
                    : form.noAnswerShort || ''
            }
            if (id === 'add') {
                const response = await Api.groupsCreate(formData)
                if (response?.data?.status === 'ok') {
                    navigate('/groups')
                }
            } else {
                const response = await Api.groupsUpdate(id, formData)
                if (response?.data?.status === 'ok') {
                    navigate('/groups')
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error saving group')
            console.error('Error saving group:', error)
        }
    }


    return (
        <Wrapper>
            <div className="tableParent">
                <Paper sx={groupPageStyles.paper}>
                    <Box sx={groupPageStyles.headerBox}>
                        <IconButton
                            size="small"
                            sx={{ color: primaryColor, fontSize: 18, '&:hover': { backgroundColor: `${primaryColor}15` } }}
                            onClick={handleGoBack}
                            aria-label="Back"
                        >
                            <ArrowBackIosNewIcon sx={groupPageStyles.backIcon} />
                        </IconButton>
                        <Typography variant="h5" sx={titleTypographyStyles}>
                            {group.title[langIndex]}
                        </Typography>
                    </Box>

                    <Alert
                        icon={<InfoIcon />}
                        severity="success"
                        sx={
                            REACT_APP_SERVER !== 'ATS'
                                ? { mb: 3 }
                                : {
                                    mb: 3,
                                    border: `1px solid ${primaryColor}`,
                                    backgroundColor: `${primaryColor}10`,
                                    '& .MuiAlert-icon': { color: primaryColor },
                                }
                        }
                    >
                        <Typography variant="body2">
                            {group.info_text[langIndex]}
                        </Typography>
                    </Alert>

                    <Paper sx={{ p: 3, border: `1px solid ${primaryColor}` }}>
                        <Box sx={groupPageStyles.sectionBox}>
                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {group.group_information[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        freeSolo
                                        options={nameOptions}
                                        value={form.shortNumberName}
                                        onChange={(event, newValue) => {
                                            const value = typeof newValue === 'string' ? newValue : newValue?.value || ''
                                            setForm({ ...form, shortNumberName: value })
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            setForm({ ...form, shortNumberName: newInputValue })
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={group.short_number_name_label[langIndex]}
                                                placeholder={group.short_number_name_placeholder[langIndex]}
                                                size="small"
                                                required
                                                sx={inputStylesLocal}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={groupPageStyles.shortNumberRow}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label={group.short_number_label[langIndex]}
                                            placeholder={group.short_number_placeholder[langIndex]}
                                            value={form.shortNumber}
                                            onChange={(e) => setForm({ ...form, shortNumber: e.target.value })}
                                            variant="outlined"
                                            required
                                            sx={inputStylesLocal}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={handleGenerateShortNumber}
                                            sx={{ color: primaryColor, '&:hover': { backgroundColor: `${primaryColor}15` } }}
                                            aria-label="Generate short number"
                                        >
                                            <RefreshIcon sx={groupPageStyles.generateIcon} />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        freeSolo
                                        options={noAnswerOptions}
                                        groupBy={(option) => {
                                            if (typeof option === 'string' || !option) return ''
                                            if (option.isivr === 1) return short.ivr_lists[langIndex]
                                            if (option.isivr === 0) return short.group[langIndex]
                                            return short.no_answer[langIndex]
                                        }}
                                        renderGroup={(params) => {
                                            const isNoAnswer = params.group === short.no_answer[langIndex]
                                            if (params.group === '' || isNoAnswer) {
                                                return <li key={params.key}><ul style={groupPageStyles.listUl}>{params.children}</ul></li>
                                            }
                                            const groupKey = params.group === short.group[langIndex] ? 'group' : 'ivr'
                                            const expanded = expandedNoAnswerGroups[groupKey] !== false
                                            return (
                                                <li key={params.key}>
                                                    <ListSubheader
                                                        component="div"
                                                        sx={groupPageStyles.listSubheader}
                                                        onClick={() => setExpandedNoAnswerGroups((prev) => ({ ...prev, [groupKey]: !prev[groupKey] }))}
                                                    >
                                                        {expanded ? <ExpandLessIcon sx={groupPageStyles.expandIcon} /> : <ExpandMoreIcon sx={groupPageStyles.expandIcon} />}
                                                        {params.group}
                                                    </ListSubheader>
                                                    {expanded && <ul style={groupPageStyles.listUl}>{params.children}</ul>}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={(option) => {
                                            if (typeof option === 'string') return option
                                            if (!option) return ''
                                            return option.label || `${option.virtual}`
                                        }}
                                        value={(() => {
                                            if (!form.noAnswerShort) return null
                                            if (typeof form.noAnswerShort === 'object') return form.noAnswerShort
                                            const matchingOption = noAnswerOptions.find(s => typeof s === 'object' && s.virtual === String(form.noAnswerShort))
                                            return matchingOption || form.noAnswerShort
                                        })()}
                                        onChange={(event, newValue) => {
                                            setForm({ ...form, noAnswerShort: newValue || '' })
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            if (newInputValue && !noAnswerOptions.find(s => (typeof s === 'object' && (s.virtual === newInputValue || s.label === newInputValue)) || s === newInputValue)) {
                                                setForm({ ...form, noAnswerShort: newInputValue })
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => {
                                            if (typeof option === 'string' && typeof value === 'string') return option === value
                                            if (typeof option === 'object' && typeof value === 'object') return option.virtual === value.virtual
                                            if (typeof option === 'object' && typeof value === 'string') return option.virtual === value
                                            if (typeof option === 'string' && typeof value === 'object') return option === value.virtual
                                            return false
                                        }}
                                        loading={loading}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={group.no_answer_short_label[langIndex]}
                                                placeholder={group.no_answer_short_placeholder[langIndex]}
                                                size="small"
                                                required
                                                sx={inputStylesLocal}
                                                InputLabelProps={{ sx: inputLabelStylesLocal }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label.Mui-disabled': {
                                                color: 'rgba(0, 0, 0, 0.87)',
                                            },
                                        }}
                                        control={
                                            <Switch
                                                checked={form.simultaneousCall}
                                                disabled={Number(form.is_order) === 1}
                                                onChange={(e) => setForm({ ...form, simultaneousCall: e.target.checked })}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': { color: primaryColor },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: primaryColor },
                                                    '& .MuiSwitch-switchBase.Mui-disabled.Mui-checked': {
                                                        color: primaryColor,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-disabled.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: primaryColor,
                                                        opacity: 1,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
                                                        opacity: 1,
                                                    },
                                                }}
                                            />
                                        }
                                        label={group.simultaneous_call_label[langIndex]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        label={group.call_wait_time_label[langIndex]}
                                        placeholder={group.call_wait_time_placeholder[langIndex]}
                                        value={form.callWaitTime}
                                        onChange={(e) => setForm({ ...form, callWaitTime: e.target.value })}
                                        variant="outlined"
                                        inputProps={{
                                            min: 0,
                                        }}
                                        sx={inputStylesLocal}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={groupPageStyles.sectionBox}>
                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {ivr.send_mail[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12}>
                                    <CreatableSelect
                                        isMulti
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        styles={customStylesLocal}
                                        menuPortalTarget={document.body}
                                        placeholder="email@example + choose .com/.ru/.am"
                                        value={(Array.isArray(form.send_mail) ? form.send_mail : []).map((email) => ({
                                            label: email,
                                            value: email,
                                        }))}
                                        options={emailOptions}
                                        onChange={handleSendMailChange}
                                        onCreateOption={handleCreateEmail}
                                        onInputChange={(val) => setEmailInput(val)}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={groupPageStyles.sectionBox}>
                            <Box sx={groupPageStyles.employeeSectionHeader}>
                                <Typography variant="h6" sx={sectionTitleStyles}>
                                    {group.employee_section[langIndex]}
                                </Typography>
                                <ToggleButtonGroup
                                    value={form.is_order}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            const isOrder = Number(newValue) === 1
                                            setForm((prev) => ({
                                                ...prev,
                                                is_order: newValue,
                                                ...(isOrder ? { simultaneousCall: true } : {}),
                                            }))
                                        }
                                    }}
                                    size="small"
                                    sx={{
                                        '& .MuiToggleButton-root': {
                                            color: primaryColor,
                                            borderColor: primaryColor,
                                            '&.Mui-selected': { backgroundColor: primaryColor, color: '#fff', '&:hover': { backgroundColor: primaryColor } },
                                        },
                                    }}
                                >
                                    <ToggleButton value={0} aria-label="no ordered">
                                        {short.is_no_ordered[langIndex]}
                                    </ToggleButton>
                                    <ToggleButton value={1} aria-label="ordered">
                                        {short.is_ordered[langIndex]}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCorners}
                                onDragEnd={(event) => {
                                    const { active, over } = event
                                    if (over && active.id !== over.id) {
                                        const oldIndex = form.employees.findIndex(emp => (emp.id || form.employees.indexOf(emp)) === active.id)
                                        const newIndex = form.employees.findIndex(emp => (emp.id || form.employees.indexOf(emp)) === over.id)
                                        if (oldIndex !== -1 && newIndex !== -1) {
                                            setForm({
                                                ...form,
                                                employees: arrayMove(form.employees, oldIndex, newIndex)
                                            })
                                        }
                                    }
                                }}
                            >
                                <SortableContext
                                    items={form.employees.map(emp => emp.id || form.employees.indexOf(emp))}
                                    strategy={verticalListSortingStrategy}
                                >
                                    {form.employees.map((emp, index) => (
                                        <EmployeeCard
                                            key={`employee-${index}`}
                                            emp={emp}
                                            index={index}
                                            employees={employees}
                                            form={form}
                                            setForm={setForm}
                                            langIndex={langIndex}
                                            greenTheme={themeColors}
                                            inputStyles={inputStylesLocal}
                                            inputLabelStyles={inputLabelStylesLocal}
                                            selectStyles={selectStylesLocal}
                                            group={group}
                                            weekDays={weekDays}
                                            input={input}
                                            isOrdered={form.is_order === 1}
                                        />
                                    ))}
                                </SortableContext>
                            </DndContext>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    ...groupPageStyles.addEmployeeButton,
                                    backgroundColor: primaryColor,
                                    color: '#fff',
                                    '&:hover': { backgroundColor: hoverColor },
                                }}
                                onClick={() => {
                                    setForm({
                                        ...form,
                                        employees: [
                                            ...form.employees,
                                            {
                                                id: Date.now(),
                                                employee: '',
                                                startDay: '2',
                                                endDay: '1',
                                                startHour: '00',
                                                startMinute: '00',
                                                endHour: '23',
                                                endMinute: '59',
                                                is_order: 0,
                                            },
                                        ],
                                    })
                                }}
                            >
                                {group.add_employee[langIndex]}
                            </Button>
                        </Box>

                        <Box sx={groupPageStyles.saveButtonBox}>
                            <Button
                                variant="contained"
                                disabled={false}
                                size="small"
                                onClick={handleSave}
                                sx={{
                                    backgroundColor: primaryColor,
                                    color: '#fff',
                                    px: 3,
                                    py: 0.75,
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    minHeight: '41px',
                                    '&:hover': { backgroundColor: hoverColor },
                                }}
                            >
                                {group.save_button[langIndex]}
                            </Button>
                        </Box>
                    </Paper>
                </Paper>
            </div>
        </Wrapper>
    )
}
